import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';
import store from '../config/store';
import AssistantService from '../services/assistant';
import { CommandButton } from '../models/assistant/interfaces/Command';

type Command = Pick<CommandButton, 'button_text' | 'action'>;

export default function useAssistantCommand() {
  const history = useHistory();

  const runCommandInAssistant = useCallback(
    (command: Command, analyticsData: unknown) => {
      history.push('/assistant/commands', { command, analyticsData });
    },
    [history]
  );

  const buildCommandAction = useCallback(
    (integrationId: string, commandName: string) => {
      const state = store.getState();

      // For canvas commands (commands with render_client_side: true)
      // Use /details/ endpoint which returns HTML React app
      return {
        type: 'navigation',
        navigation: {
          type: 'internal',
          url: `/eva/api/v1/programs/${state.program.id}/assistant/integrations/${integrationId}/details/${commandName}`,
        },
      };
    },
    []
  );

  const fetchCommandAction = useCallback(
    async (integrationId: string, commandName: string) => {
      const commandData = await new AssistantService().fetchCommandDetail(
        integrationId,
        commandName
      );

      return commandData.action;
    },
    []
  );

  return {
    runCommandInAssistant,
    buildCommandAction,
    fetchCommandAction,
  };
}
